module.exports = __webpack_public_path__ + "img/contact_img1.eafb9a23.png";